import state from './alarm.state'
import mutations from './alarm.mutations'
import actions from './alarm.actions'

export default {
  state,
  mutations,
  actions
}
